const PLAYBACK_POLL_MS = 100;

const sleepMs = () =>
  new Promise((resolve) => setTimeout(resolve, PLAYBACK_POLL_MS));

export async function waitForPlaybackEnd({
  getOffset,
  isStreamActive,
  targetSamples,
  isAnswerActive,
  sleep,
}: {
  getOffset: () => number | undefined;
  isStreamActive: () => boolean;
  targetSamples: number;
  isAnswerActive: () => boolean;
  sleep?: () => Promise<void>;
}) {
  const sleepFunction = () => (sleep ? sleep() : sleepMs());

  while (isAnswerActive()) {
    if (!isStreamActive()) break;

    const offset = getOffset();

    if (offset && offset >= targetSamples) {
      // If audio finished
      break;
    }

    await sleepFunction(); // Wait PLAYBACK_POLL_MS seconds and try again
  }
}
